import { supabase } from "@/integrations/supabase/client";

export type ActivityAction = "created" | "updated" | "deleted" | "archived" | "restored" | "completed" | "uncompleted";
export type EntityType = "reminder" | "task_item" | "homework";

interface LogParams {
  familyId: string;
  childId: string;
  action: ActivityAction;
  entityType: EntityType;
  entityId: string;
  changes?: Record<string, { old: unknown; new: unknown }>;
}

/**
 * Fire-and-forget audit log insert. Never throws.
 */
export async function logActivity(params: LogParams) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase.from("child_activity_log" as any).insert({
      family_id: params.familyId,
      child_id: params.childId,
      actor_user_id: user.id,
      action: params.action,
      entity_type: params.entityType,
      entity_id: params.entityId,
      changes: params.changes ?? null,
    });
  } catch {
    // silently fail – audit logs should never block UX
  }
}
